export const USERDATAEMPLOYEE_SHOW_RESET = 'USERDATAEMPLOYEE_SHOW_RESET'
export const USERDATAEMPLOYEE_SHOW_SET_ERROR = 'USERDATAEMPLOYEE_SHOW_SET_ERROR'
export const USERDATAEMPLOYEE_SHOW_SET_RETRIEVED = 'USERDATAEMPLOYEE_SHOW_SET_RETRIEVED'
export const USERDATAEMPLOYEE_SHOW_TOGGLE_LOADING = 'USERDATAEMPLOYEE_SHOW_TOGGLE_LOADING'
